<template>
  <div id="data-list-list-view" class="data-list-container">
    <add :isSidebarActive="addPrompt" @closePrompt="toggleAddPrompt" :callBackFunction="callBackAdd" />

    <vs-table ref="table" :max-items="10" :data="archives">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div @click="getArchives(1)" class="
                                      btn-add-new
                                      p-3
                                      mb-4
                                      mr-4
                                      rounded-lg
                                      cursor-pointer
                                      flex
                                      items-center
                                      justify-center
                                      text-lg
                                      font-medium
                                      text-base text-primary
                                      border border-solid border-primary
                                    ">
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
          <div @click="addPrompt = true" class="
                                      btn-add-new
                                      p-3
                                      mb-4
                                      mr-4
                                      rounded-lg
                                      cursor-pointer
                                      flex
                                      items-center
                                      justify-center
                                      text-lg
                                      font-medium
                                      text-base text-primary
                                      border border-solid border-primary
                                    ">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Ajouter</span>
          </div>
          <div @click="goTo()" class="
                                    btn-add-new
                                    p-3
                                    mb-4
                                    mr-4
                                    rounded-lg
                                    cursor-pointer
                                    flex
                                    items-center
                                    justify-center
                                    text-lg
                                    font-medium
                                    text-base text-primary
                                    border border-solid border-primary
                                  ">
            <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Consulter les archives</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input v-model="stringSearch" @keypress.enter="getArchives()" type="text"
            class="input-search vs-table--search-input" />
          <i class="vs-icon notranslate icon-scale material-icons null">search</i>
        </div>
      </div>

      <template slot="thead">
        <vs-th>Archive</vs-th>
        <vs-th>Date création</vs-th>
        <vs-th>Date début</vs-th>
        <vs-th>Date fin</vs-th>
        <vs-th>Utilisateur</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="40%">
              <span class="">{{ tr.name }} </span>
            </vs-td>
            <vs-td width="20%">
              <p class="product-category">{{ tr.created_at }}</p>
            </vs-td>
            <vs-td width="20%">
              <p class="product-category">{{ tr.date_deb }}</p>
            </vs-td>
            <vs-td width="20%">
              <p class="product-category">{{ tr.date_fin }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-price">{{ tr.user_owner }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
  </div>
</template>

<script>
import { _buildQuery } from "../../helpers/helper";
import Add from "./add";
export default {
  name: "archive",
  components: { Add },
  data: () => ({
    page: 1,
    last_page: 1,
    archives: [],
    addPrompt: false,
    stringSearch: "",
  }),
  watch: {
    page(value) {
      this.getArchives(value);
    },
  },
  methods: {
    goTo(){
      window.open('http://10.77.152.62:8081', '_blank');
    },
    toggleAddPrompt(val = false) {
      this.addPrompt = val;
    },
    getArchives(page) {
      this.$vs.loading();
      let params = {
        page: page,
        name: this.stringSearch,
        paginate: '1'
      }
      this.$http
        .get("/database-archives" + _buildQuery(params) )
        .then((response) => {
          this.archives = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    callBackAdd(data) {
      // this.archives.unshift(data.model);
      this.getArchives();
    },
  },
  mounted() {
    this.getArchives(this.page);
  },
};
</script>

<style scoped></style>
